import React from 'react';
import useLogPage from '../useLogPage';
import LogFilters from '../LogFilters';
import LogTable from '../LogTable';
import LogStatCards from '../LogStatCards';
import { TrendChart, DonutChart } from '../LogCharts';
import { LogService } from '../../../services/activityLogService';

const STATUS_OPTIONS = [
  { value: 'success',  label: 'Success'  },
  { value: 'failed',   label: 'Failed'   },
  { value: 'pending',  label: 'Pending'  },
  { value: 'refunded', label: 'Refunded' },
];

const statusBadge = (v) => {
  const map = {
    success:  ['#D1FAE5','#065F46'],
    failed:   ['#FEE2E2','#991B1B'],
    pending:  ['#FEF3C7','#92400E'],
    refunded: ['#E0F2FE','#0369A1'],
  };
  const [bg, color] = map[v?.toLowerCase()] || ['#F3F4F6','#374151'];
  return <span className="al-badge" style={{ background: bg, color }}>{v || '—'}</span>;
};

const COLUMNS = [
  { key: 'id',             label: '#',        render: (v) => <span className="al-mono">{v}</span> },
  { key: 'transaction_id', label: 'Txn ID',   render: (v) => <span className="al-mono">{v || '—'}</span> },
  { key: 'order_id',       label: 'Order ID', render: (v) => <span className="al-mono">{v || '—'}</span> },
  { key: 'user_id',        label: 'User ID',  render: (v) => <span className="al-mono">{v || '—'}</span> },
  { key: 'method',         label: 'Method' },
  { key: 'amount',         label: 'Amount',   render: (v) => v ? `₹${Number(v).toLocaleString('en-IN')}` : '—' },
  { key: 'status',         label: 'Status',   render: statusBadge },
  { key: 'gateway',        label: 'Gateway' },
  { key: 'created_at',     label: 'Time',     render: (v) => v ? new Date(v).toLocaleString('en-IN') : '—' },
];

const PaymentLog = () => {
  const lp = useLogPage(LogService.payments);
  const s = lp.stats || {};

  const handleExport = () => {
    const { search, status, dateFrom, dateTo } = lp.filters;
    LogService.exportPayments({
      ...(search   ? { search }              : {}),
      ...(status   ? { status }              : {}),
      ...(dateFrom ? { date_from: dateFrom } : {}),
      ...(dateTo   ? { date_to:   dateTo   } : {}),
      format: 'excel',
    });
  };

  const stats = [
    { label: 'Total Transactions', value: lp.totalItems.toLocaleString(),                color: '#8B5CF6' },
    { label: 'Success',            value: (s.success  ?? 0).toLocaleString(),            color: '#10B981' },
    { label: 'Failed',             value: (s.failed   ?? 0).toLocaleString(),            color: '#EF4444' },
    { label: 'Total Amount',       value: s.total_amount != null ? `₹${Number(s.total_amount).toLocaleString('en-IN')}` : '—', color: '#F55D00' },
  ];

  const donutData = lp.donut.length
    ? lp.donut
    : Object.entries(s.breakdown || {}).map(([name, value]) => ({ name, value }));

  return (
    <div className="al-page">
      <LogStatCards stats={stats} />

      <div className="al-charts">
        <TrendChart title="Payment Volume Over Time" data={lp.trend} color="#8B5CF6" />
        <DonutChart  title="Payment Status"          data={donutData} />
      </div>

      <LogFilters
        filters={lp.filters}
        onFilterChange={lp.handleFilterChange}
        onApply={lp.handleApply}
        onReset={lp.handleReset}
        statusOptions={STATUS_OPTIONS}
        loading={lp.loading}
      />

      <LogTable
        title="Payment Logs"
        columns={COLUMNS}
        rows={lp.rows}
        loading={lp.loading}
        error={lp.error}
        page={lp.page}
        totalPages={lp.totalPages}
        totalItems={lp.totalItems}
        pageSize={lp.filters.pageSize}
        onPageChange={lp.handlePageChange}
        onExport={handleExport}
        onRefresh={lp.handleRefresh}
      />
    </div>
  );
};

export default PaymentLog;
